// Bounce a magic-link session to /verify until it has confirmed who it is.
//
// This is the pleasant path, not the enforcement. Enforcement is server-side in
// flow/accounts/dependencies.py, which refuses every endpoint while the session
// is pending — so a client who never loads this middleware still gets nothing.
// What this buys is a redirect instead of a page full of failed requests.
//
// It reads the flag off the store rather than asking the server, because the
// boot state already carries it (flow/accounts/state.py). In production that
// is the page's window.STATE (flow/root.py), not a /state/ request — so the
// page has to build it with the request, or the flag is never set and this
// middleware waves every magic link straight through. One less round trip per
// navigation.
export default function ({ store, redirect, route }) {
    // `identityPending` is the guard, and it is server-set: only a magic-link
    // login by a CLIENT is ever pending (flow/accounts/auth.py), and
    // magic_redirect refuses non-clients outright. So agents, admins, HR and
    // brokers never reach the redirect below whatever their role getter says —
    // role is deliberately not consulted here, because duplicating that rule in
    // the browser is how the two drift apart.
    if (!store.getters.identityPending) { return }
    // Without this the checkpoint redirects to itself, forever.
    if (route.path === '/verify') { return }
    // #648: the feedback page is token-only. Its endpoints are
    // @allow_unauthenticated and never read the session, so a pending session
    // in the same browser has nothing to protect there.
    if (route.path.replace(/\/$/, '') === '/feedback') { return }

    // Remember where they were headed so the checkpoint can hand them back.
    return redirect('/verify', { ...route.query, next: route.fullPath })
}
